module.exports = __webpack_public_path__ + "img/banner.9c5152a3.png";